const handleMeetTheTeamFilterClick: (event: any) => void = (event) => {
  try {
    const target: any = event.currentTarget || event.target;
    const parent: any = target.closest('.meetTheTeamFeedParent');
    const filterTabs: any = parent.getElementsByClassName('tab');
    const items: any = parent.getElementsByClassName('feedItem');
    const targetSlug: string = target.dataset.slug;

    for (let i = 0; i < filterTabs.length; i++) {
      filterTabs[i].classList.remove('active');
    }

    target.classList.add('active');

    for (let i = 0; i < items.length; i++) {
      const itemSlugs: any = JSON.parse(items[i].dataset.slug);

      items[i].classList.remove('active');

      if (itemSlugs.indexOf(targetSlug) > -1) {
        items[i].classList.add('active');
      }
    }
  } catch (error) {
    console.log(error);
  }
};
